import { Box, Button, Link, Portal, Typography } from "@mui/material";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";

const CookiesNotification = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    Cookies.set("consent", "true", {
      expires: 365 * 10,
      sameSite: "strict",
    });
    setOpen(false);
  };

  useEffect(() => {
    const consent = Cookies.get("consent");

    if (!consent) {
      setOpen(true);
    }
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Portal>
      <Box
        sx={{
          alignItems: "center",
          backgroundColor: "rgba(17, 25, 40, 0.92)",
          color: "common.white",
          bottom: 24,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          left: "50%",
          maxWidth: 680,
          p: 2,
          position: "fixed",
          transform: "translateX(-50%)",
          width: "calc(100% - 24px)",
          zIndex: 1500,
          borderRadius: 2,
          boxShadow: 8,
        }}
      >
        <Typography
          variant="body1"
          color="inherit"
          sx={{
            fontSize: "0.7rem",
            textAlign: "justify",
          }}
        >
          Usamos Cookies para garantizar su seguridad y proveer servicios
          personalizados. Puede leer sobre nuestra política en{" "}
          <Link
            component="a"
            color="inherit"
            underline="always"
            href="https://arkadu.com/privacy-policy"
            target="_blank"
          >
            Política de Privacidad
          </Link>
          .
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end"
          }}>
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            sx={{
              fontSize: "0.7rem",
              textAlign: "justify",
              padding: "0.5rem 1rem",
            }}
          >
            De acuerdo
          </Button>
        </Box>
      </Box>
    </Portal>
  );
};

export default CookiesNotification;
